import React, { useEffect, useRef, useState } from 'react';

const API_KEY = 'f8b3da4e7a7049799e876d10e50103e9';

const symbols = [
  'OANDA:XAUUSD',
  'BINANCE:BTCUSDT',
  'BINANCE:ETHUSDT',
  'NASDAQ:AAPL',
  'NASDAQ:TSLA',
  'NASDAQ:GOOGL',
  'NYSE:JPM',
  'NYSE:DIS'
];

const formatSymbolForAPI = (symbol) => {
  const s = symbol.split(':')[1] || symbol;
  return s.slice(0, 3) + '/' + s.slice(3);
};

const SignalCard = ({ data }) => {
  const { symbol, close, change, percent_change, updated, signal } = data;

  const colorClass =
    signal === 'Buy' ? 'text-green-600' :
    signal === 'Sell' ? 'text-red-600' : 'text-yellow-600';

  return (
    <div className="w-[250px] flex-shrink-0 bg-black border rounded-lg shadow p-4">
      <div className="text-sm font-bold mb-1">📡 {symbol || '--'}</div>
      <div><strong>Price:</strong> {close || '--'}</div>
      <div><strong>Change:</strong> {change || '--'} ({percent_change || '--'}%)</div>
      <div><strong>Signal:</strong> <span className={`font-bold ${colorClass}`}>{signal || 'Neutral'}</span></div>
      <div className="text-gray-400 text-xs mt-1">Updated: {updated || '--:--:--'}</div>
    </div>
  );
};

const SignalTicker = () => {
  const [signals, setSignals] = useState([]);
  const scrollRef = useRef(null);
  const intervalRef = useRef(null);
  const scrollAmount = 266; // 250px card + 16px margin

  useEffect(() => {
    const fetchData = async () => {
      const results = await Promise.all(symbols.map(async (s) => {
        const clean = formatSymbolForAPI(s);
        try {
          const res = await fetch(`https://api.twelvedata.com/quote?symbol=${clean}&apikey=${API_KEY}`);
          const data = await res.json();

          const pct = parseFloat(data.percent_change || 0);
          const signal =
            pct > 0.3 ? 'Buy' :
            pct < -0.3 ? 'Sell' : 'Neutral';

          return {
            symbol: s, // keep original
            close: data.close,
            change: data.change,
            percent_change: data.percent_change,
            updated: new Date().toLocaleTimeString(),
            signal
          };
        } catch {
          return null;
        }
      }));
      setSignals(results.filter(Boolean));
    };

    fetchData();
    const interval = setInterval(fetchData, 30000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    startAutoScroll();
    return stopAutoScroll;
  }, []);

  const startAutoScroll = () => {
    stopAutoScroll();
    intervalRef.current = setInterval(() => {
      if (scrollRef.current) {
        scrollRef.current.scrollBy({ left: scrollAmount, behavior: 'smooth' });
      }
    }, 3000);
  };

  const stopAutoScroll = () => {
    if (intervalRef.current) clearInterval(intervalRef.current);
  };

  const scrollLeft = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
    }
  };

  const scrollRight = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    }
  };

  return (
    <div className="mt-6 relative">
      <h3 className="text-md font-semibold mb-2">📊 Market Signal Ticker</h3>

      <button onClick={scrollLeft} className="absolute left-0 top-[50%] z-10 bg-white shadow px-2 py-1 rounded-full -translate-y-1/2">
        ⬅️
      </button>
      <button onClick={scrollRight} className="absolute right-0 top-[50%] z-10 bg-white shadow px-2 py-1 rounded-full -translate-y-1/2">
        ➡️
      </button>

      <div
        ref={scrollRef}
        onMouseEnter={stopAutoScroll}
        onMouseLeave={startAutoScroll}
        className="flex overflow-x-auto no-scrollbar space-x-4 mx-auto px-2"
        style={{
          scrollBehavior: 'smooth',
          width: '1064px'
        }}
      >
        {signals.map((s, idx) => (
          <SignalCard key={idx} data={s} />
        ))}
      </div>
    </div>
  );
};

export default SignalTicker;
